import React from 'react';
import '../profile.css';
import axios from 'axios';
import { PayPalButton } from "react-paypal-button-v2";
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
const queryString = require('query-string');


function getTutor(tutorEmail){
    var myParam = {
        email: tutorEmail
    }
  
    axios.post("https://auxilliabackend.herokuapp.com/getTutorProfile",myParam)
    .then(function (response) {
      
      const data = response.data;
      console.log(data);

      var classes = "";
      for (var i = 0;i <  data.Classes.length;i++)
      {
        classes = classes + data.Classes[i] + "\n";
      }

      var times = [];
      for (var i = 0;i <  data.AvailableTimes.length;i++)
      {
        times.push(data.AvailableTimes[i]);
      }




      window.tutorProf.addTutorToState(data.ClassYear,classes,data.Email,data.Name,data.Price,times);  
      return data;
  
  
      //window.location.reload(true);
    })
    .catch(function (error) {
      console.log(error);
    });
  }


function getZoom(topic,comments,tutorName,tutorEmail,timee,studentEmail)
{
    var myParam = {topic:topic,comments:comments,tutorName:tutorName,tutorEmail:tutorEmail,timee:timee,studentEmail:studentEmail};

    axios.post("https://auxilliabackend.herokuapp.com/getMeetingNow",myParam)
    .then(function (response) {

    const data = response.data;
    console.log("response:")
    console.log(data);


    //window.location.reload(true);
    })
    .catch(function (error) {
    console.log("SOMETHING WENT WRONG");
    console.log(error);
    });
}

//   function transSucces()
//   {
//     const history = useHistory();
//     history.push({pathname: '/reserve'});
//   }

//Functional Component 
class tutorProfilePage extends React.Component{
    constructor(props)
    {
        super(props);
        window.tutorProf = this;
        this.state = {
        classYear: "",
        classes: "",
        email:"",
        name:"",
        price:"",
        times:[],
        class:"",
        comments:""
        }
    }

    componentDidMount()
    {
        const mail = queryString.parse(window.location.search).email;
        getTutor(mail);
    }

    addTutorToState(classYear,classes,email,name,price,times)
    {
        this.setState({
            classYear: classYear,
            classes: classes,
            email:email,
            name:name,
            price:price,
            times:times
        });
        
    }

    handleInputChange = (event) => {
        console.log("Changing", event.target.name);
        this.setState({
          [event.target.name]: event.target.value
        })
      }

      postMoney(){
        var myParam = {email: this.state.email, amount: this.state.price};

        axios.post("https://auxilliabackend.herokuapp.com/postTransaction",myParam)
        .then(function (response) {

        const data = response.data;
        console.log("response:")
        console.log(data);


        //window.location.reload(true);
        })
        .catch(function (error) {
        console.log("SOMETHING WENT WRONG");
        console.log(error);
        });
    }

    reroute(){
        getZoom("CSCEC",this.state.comments,this.state.name,this.state.email,this.state.times[0],localStorage.getItem('email'));
        this.props.history.push({pathname: '/reserve'});
    }
    
    render()
    {
        return (
            <div className="App">
                <body className = "profile-body">

                    {/* user banner */}
                    <div class = "profileBanner">
                        <div class = "profileName"> {/* The name at the top */}
                            <h3>{this.state.name}</h3>
                        </div>

                        <div class = "profileInfoData"> {/* This is under the name and where all the info goes should be an inline block*/}
                            <div class = "InfoData">
                                <h4>Email</h4>
                                <p>{this.state.email}</p>
                            </div>

                            <div class = "InfoData">
                                <h4>Classes</h4>
                                <p>{this.state.classes}</p>
                            </div>

                            <div class = "InfoData">
                                <h4>Class Year</h4>
                                <p>{this.state.classYear}</p>
                            </div>

                            <div class = "InfoData">
                                <h4>Hourly Rate</h4>
                                <p>{this.state.price}</p>
                            </div>
                        </div>
                    </div>

                    <div class = "timesSchedule">   {/* should be an inline block */}
                        {/* <div class = "rButtons">  

                        </div> */}
                        
                        <div class = "rDrop">
                            <h1>Schedule with {this.state.name}:</h1>
                            <form class = "inline">
                                <div>
                                    <p>Times Available:</p>
                                    
                                    <select id="cars" name="cars">
                                        {this.state.times.map((item,i) => {return(<option selected={this.state.times[i]} key={this.state.times[i]} value={this.state.times[i]}>{this.state.times[i]}</option>)})}
                                    </select>
                                    {/* <input type="submit"></input> */}
                                </div>

                                <div class = "space">
                                </div>

                                <div class = "comments">
                                    <p>Comments:</p>
                        
                                    <input type = "text" name = "comments" onChange={this.handleInputChange} placeholder = "Put anything you would like the tutor to know here" ></input>
                                    {/* <input type = "submit" name = "" value = "Submit" ></input > */}
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class = "submission">
                        <p>When you click on any of the PayPal buttons it will ask you to pay then confirm your time.</p>
                        <PayPalButton
                            amount={this.state.price}
                            shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
                            onSuccess={(details, data) => {
                            console.log("IT WENT THRU");
                            alert("Transaction completed by " + details.payer.name.given_name);
                            {this.postMoney()}
                            {this.reroute()}



                            //return <Redirect to="/reserve"></Redirect>;
                            // OPTIONAL: Call your server to save the transaction
                            // return fetch("/paypal-transaction-complete", {
                            //     method: "post",
                            //     body: JSON.stringify({
                            //     orderId: data.orderID
                            //     })
                            // });
                            }}
                            options={{
                                clientId: "Afb7pKFG_ajh6JmL2e0NyBFomaJGCd76qmQ6-eQKKR8sVGLXnM1jxvzADDFzjUKYU5-s8GkLozC-Aj78"
                            }}
                        />
                    </div>
        
                    
                </body>
            </div>
        );
    }
  }



export default tutorProfilePage;